import styled from 'styled-components'

import { colors } from 'app/theme/colors'

export const Container = styled.div`
  display: flex;
  gap: 24px;
  height: 100%;
`

export const FormContainer = styled.div`
  flex: 1;
  padding: 24px;
  overflow-y: auto;
  max-height: 70vh;
`

export const PreviewContainer = styled.div`
  flex: 0.3;
  display: flex;
  flex-direction: column;
`
export const PreviewImage = styled.img`
  width: 100%;
  object-fit: contain;
`

export const SectionHeading = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 2px 0 2px 0;
`

export const Divider = styled.hr`
  border: none;
  height: 1px;
  background: #e0e0e0;
  margin: 2px 0;
`

export const NotesContainer = styled.div`
  color: #00000080;
`

export const NotesTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  margin: 0;
`

export const NotesList = styled.ul`
  margin: 0;
  padding-left: 20px;
  font-size: 13px;
`

export const NotesItem = styled.li`
  margin-bottom: 4px;
`

export const ExternalLinkContainer = styled.div``

export const ExternalLinkText = styled.span`
  color: ${colors.ohOrange};
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 700;
}
`
